import React from 'react'
import modelMap from 'hec/builder/model-map'
import * as Icons from 'hec/assets/icons'
import IconPicker from 'hec/components/icon-picker/icon-picker'
import {IconProps} from './types'

const iconNames = Object.keys(Icons)

export const Icon: React.FC<IconProps> = ({...props}) => {
    const {iconName, useReference, CustomIcon, attributes, useBuilderImageAttributes} = props
    return (
        <IconPicker
            iconName={iconName}
            attributes={attributes}
            useReference={useReference}
            CustomIcon={CustomIcon}
            useBuilderImageAttributes={useBuilderImageAttributes}
        />
    )
}

export const IconDefinition = {
    component: Icon,
    name: 'IconPicker',
    noWrap: true,
    image: 'https://unpkg.com/css.gg@2.0.0/icons/svg/smile.svg',
    inputs: [
        {
            name: 'iconName',
            friendlyName: 'Icon',
            type: 'string',
            helperText: 'Select from the available icon set',
            enum: iconNames,
            required: true,
            showIf: `options.get('useReference') !== true`
        },
        {
            name: 'useReference',
            friendlyName: 'Reference a custom icon',
            helperText: 'Reference a custom icon uploaded to the Custom Icons model via Builder',
            type: 'boolean',
            defaultValue: false
        },
        {
            name: 'useBuilderImageAttributes',
            friendlyName: 'Use Builder Image Attributes',
            helperText:
                'Apply attributes like width, height, and spacing set in the Builder editor',
            type: 'boolean',
            defaultValue: true,
            showIf: `options.get('useReference') === true`
        },
        {
            name: 'CustomIcon',
            type: 'reference',
            model: modelMap.customIcons,
            required: true,
            showIf: `options.get('useReference') === true`
        }
    ]
}

export default Icon
